<template>
  <div class="book" :class="{guide: book.guide, finalized: !book.editable}">
    <!--封面内容-->
    <div class="img-btn" @click="previewLink">
      <cover :book="book"></cover>
    </div>
    <!--书籍内容-->
    <div class="book-info">
      <h4 class="book-title text-ellipsis">
        <a @click="previewLink">
          <i :class="['fa', iconClass]" aria-hidden="true"></i>
          {{book.title}}
        </a>
      </h4>
      <div class="info-detail">
        <p class="hidden-xs">{{book.author}}</p>
        <p v-if="book.totalPage">{{innerStyle}} {{$t('book.page', { page: book.totalPage })}}</p>
        <template v-if="book.type === 'diarybook'">
          <template v-if="book.totalPage">
            <p class="hidden-xs">{{$t('book.labelStartedWith')}}: {{book.startDate}}</p>
            <p class="hidden-xs">{{$t('book.labelEndWith')}}: {{book.endDate}}</p>
          </template>
          <p class="text-mini">
            <span v-if="book.createdAt === book.updatedAt || book.updatedAt">
              <i class="icon ion-ios-information text-done"></i>
              {{$t('book.labelCreatedAt')}} {{formatDate(book.createdAt)}}
            </span>
            <span v-else>
              <i class="icon ion-android-alert text-orange"></i>
              {{$t('book.labelUpdatedAt')}} {{formatDate(book.updatedAt)}}
            </span>
          </p>
        </template>
      </div>
      <div class="book-btns">
        <button class="btn default edit" @click="handleEdit" v-if="book.editable">
          {{$t('book.buttonEdit')}}
        </button>
        <router-link :to="handleLink('review', book.bid, book.totalPage, book.source)" v-else>
          <button class="btn default">
            {{$t('book.buttonPreview')}}
          </button>
        </router-link>
        <button class="btn red purchase" :class="{disabled: isChecking}" @click.prevent="checkBookStatus"
                v-if="book.totalPage">
          <i class="fa fa-spinner fa-spin" v-if="isChecking"></i>
          {{$t('book.buttonPurchase')}}
        </button>
      </div>
    </div>
    <div class="book-item__action bin" @click="deleteBook">
      <i class="fa fa-times" aria-hidden="true"/>
    </div>
    <transition name="slide-down">
      <div class="action-wrapper" v-if="showAction" @click="showAction = false">
        <div class="sub-action" @click.stop="shareBook" v-show="false">
          <div><i class="fa fa-share"></i></div>
          <p>分享</p>
        </div>
        <div class="sub-action" @click.stop="deleteBook">
          <div>
            <i class="fa fa-trash"></i>
          </div>
          <p>{{$t('button.delete')}}</p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import config from 'src/app.config'
import FBShare from '../../../mixins/FBShare'
import { mapGetters } from 'vuex'
import Cover from '../../../components/Cover'
import api from 'src/api'

export default {
  name: 'book',
  components: { Cover },
  mixins: [FBShare],
  props: {
    book: {
      type: Object,
      default: function () {
        return {
          bid: '',
          title: '',
          author: '',
          cover: '',
          createdAt: new Date(),
          updatedAt: new Date(),
          endAt: '',
          status: '0',
          template: 'common.text.a5Waterfall',
          totalPage: 0,
          editable: true,
          public: false,
          guide: false
        }
      }
    }
  },
  data () {
    return {
      template: config.templates,
      finalizedConfig: [
        {
          langRef: 'jp',
          className: 'jp'
        },
        {
          langRef: 'en',
          className: 'en'
        },
        {
          langRef: 'zh',
          className: 'zh'
        },
        {
          langRef: 'ko',
          className: 'en'
        }
      ],
      langRef: 'en',
      showAction: false,
      isChecking: false
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    iconClass () {
      if (this.book.type === 'photobook') {
        return 'fa-photo text-primary'
      }
      if (this.book.type === 'calendar') {
        return 'fa-calendar text-primary '
      }
      return 'fa-book text-fb'
    },
    innerStyle () {
      const {
        template,
        templateStyle,
        design
      } = this.book
      let title
      let material
      let style
      switch (this.book.type) {
        case 'diarybook':
          return this.$t(template)
        case 'photobook':
          if (template === 'album') {
            return 'A4雜誌冊'
          }
          title = t => `${t}相片書`
          material = design.template.includes('leather') ? '皮面' : '布藝'
          style = '簡約版'
          if (templateStyle === 'magazine-1' && templateStyle.includes('travel')) {
            style = '旅行風'
          }
          if (templateStyle.includes('love')) {
            style = '爱情風'
          }
          if (templateStyle.includes('japan')) {
            style = '日系風'
          }
          if (templateStyle.includes('baby')) {
            style = '幼兒版'
          }
          if (templateStyle.includes('child')) {
            style = '童趣版'
          }
          return title(material) + ' ' + style
        case 'calendar':
          return '月曆'
        default:
          return ''
      }
    }
  },
  methods: {
    handleEdit () {
      if (this.book.type === 'photobook' || this.book.type === 'calendar') {
        window.location.href = `https://ipastbook.com/app/design/album/?aid=${this.book.bid}&type=${this.book.type}&from=${encodeURIComponent(
          window.location.href)}`
        return
      }
      const {
        bid,
        totalPage,
        source,
        isGettingPages,
        isGettingPosts,
        pagesInitialized,
        postsInitialized,
        patched,
        insInitialized,
        isGettingIns
      } = this.book
      if (!isGettingPages && !isGettingPosts && !pagesInitialized && !postsInitialized && !patched && !totalPage &&
        !insInitialized && !isGettingIns) {
        this.$emit('empty')
        return
      }
      if (!totalPage) {
        if (pagesInitialized || isGettingPosts) {
          this.$router.push({
            name: 'selection',
            query: {
              bid,
              sid: source,
              tab: 'facebook'
            }
          })
          return
        }
        // 当前个人页数据未导入，粉丝页数据已经导入时
        if (pagesInitialized && (!postsInitialized || isGettingPosts || !insInitialized || isGettingIns)) {
          this.$router.push({
            name: 'selection',
            query: {
              bid,
              sid: source,
              tab: 'pages'
            }
          })
          return
        }
        // 当前未导入个人页、粉丝页且当前只存在补写内容时
        if (!postsInitialized && !pagesInitialized && !insInitialized && patched) {
          this.$router.push({
            name: 'selection',
            query: {
              bid,
              sid: source,
              tab: 'patch'
            }
          })
          return
        }
        // 当前 Instagram 数据导入，其他数据未导入时
        if (!totalPage && (insInitialized || isGettingIns)) {
          this.$router.push({
            name: 'selection',
            query: {
              bid,
              sid: source,
              tab: 'instagram'
            }
          })
          return
        }
        this.$router.push({
          name: 'selection',
          query: {
            bid,
            sid: source
          }
        })
      }
      if ((postsInitialized || pagesInitialized || patched || insInitialized) && totalPage) {
        this.$router.push({
          name: 'preview',
          query: {
            bid,
            sid: source
          }
        })
        return
      }
      this.$router.push({
        name: 'selection',
        query: {
          bid,
          sid: source
        }
      })
    },
    previewLink () {
      if (this.book.type === 'photobook' || this.book.type === 'calendar') {
        window.location.href = `https://ipastbook.com/app/design/album/?aid=${this.book.bid}&type=${this.book.type}&from=${encodeURIComponent(
          window.location.href)}`
        return
      }
      if (!this.book.totalPage) {
        this.handleEdit()
      }
      if (this.book.totalPage) {
        if (!this.book.editable) {
          this.$router.push({
            name: 'review',
            query: {
              bid: this.book.bid,
              sid: this.book.source
            }
          })
          return
        }
        this.$router.push({
          name: 'preview',
          query: {
            bid: this.book.bid,
            sid: this.book.source
          }
        })
      }
    },
    formatDate (date) {
      return this.$moment(date).format('YYYY/MM/DD')
    },
    shareBook () {
      this.showAction = false
      this.FBShareBook(this.book.bid)
    },
    checkBookStatus () {
      if (this.book.type !== 'diarybook') {
        if (this.isChecking) return
        this.isChecking = true
        const checkHandler = {
          photobook: api.checkPhotoBook,
          calendar: api.checkCalendar
        }
        const request = checkHandler[this.book.type]
        request(this.book.bid).then(data => {
          this.isChecking = false
          const {
            pageIndex,
            pagesValid
          } = data
          if (pageIndex + 1) {
            this.$confirm({
              title: `书籍第${pageIndex + 1}頁圖片缺失`,
              okText: '查看',
              cancelText: '知道了',
              onOk: (modal) => {
                modal.close()
                const origin = /test|localhost/.test(window.location.origin) ? window.location.origin : 'https://ipastbook.com'
                window.location.href = `${origin}/app/design/album/?aid=${this.book.bid}&type=${this.book.type}`
              }
            })
          } else if (pagesValid) {
            const tip = pagesValid < 0 ? '書籍頁數太少，再去寫寫吧' : '書籍頁數太多了，去刪點頁數吧'
            this.$confirm({
              title: tip,
              okText: '查看',
              cancelText: '知道了',
              onOk: (modal) => {
                modal.close()
                const origin = /test|localhost/.test(window.location.origin) ? window.location.origin : 'https://ipastbook.com'
                window.location.href = `${origin}/app/design/album/?aid=${this.book.bid}&type=${this.book.type}`
              }
            })
          } else {
            this.$router.push({
              name: 'order-check',
              query: {
                bid: this.book.bid,
                sid: this.book.source,
                bookType: this.book.type
              }
            })
          }
        }).catch(e => {
          this.isChecking = false
        })
      } else {
        this.$router.push({
          name: 'order-check',
          query: {
            bid: this.book.bid,
            sid: this.book.source,
            bookType: this.book.type
          }
        })
      }
    },
    deleteBook () {
      this.$emit('delete', this.book)
    },
    handleLink (name, bid, page, source) {
      if (!bid) {
        this.$toast({
          message: '書籍無顯示內容'
        })
        return
      }
      return {
        name,
        query: {
          bid,
          sid: source
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.book {
  width: 100%;
  position: relative;
  text-align: center;
  padding: 2rem;
  border: 1px solid #eee;
  overflow: hidden;
  border-radius: 4px;
  background-color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  font-size: 16px; // 父元素.book-list font-size 0，消除 inline-block 的margin问题

  .marked {
    display: none;
  }

  .img-btn.guide-cover {
    display: none;
  }

  .guide-title {
    display: none;
  }

  &.guide {
    .img-btn {
      &.guide-cover {
        display: inline-block;
      }

      &.cover-image {
        display: none;
      }
    }

    .book-info {
      display: none;
    }

    .guide-title {
      margin-left: 10px;
      display: inline-block;
      vertical-align: middle;
    }
  }

  .cover-image {
    a {
      display: inline-block;
      position: relative;
      z-index: 2;
    }
  }

  &.finalized {
    .marked {
      display: block;
    }

    .edit {
      display: none;
    }
  }

  @media screen and (max-width: 600px) {
    padding: 20px;
  }

  .img-btn {
    position: relative;
    display: block;
    width: (560px / 3);
    color: inherit;
    background: {
      repeat: no-repeat;
      size: cover;
      color: #fff
    };
    transition: all .25s;
    cursor: pointer;
    @media (max-width: 600px) {
      width: (560px / 5);
    }
    @media (max-width: 330px) {
      width: (560px / 5);
    }
  }

  .book-info {
    min-width: 0;
    text-align: left;
    @media (max-width: 600px) {
      width: 11em;
    }
    @media (max-width: 330px) {
      width: 9em;
    }
  }

  .book-title {
    font-size: 20px;
    margin-bottom: 6px;
    cursor: pointer;
    @media (max-width: 767px) {
      font-size: 16px;
    }

    a:hover {
      color: #555;
    }

    .fb-icons-wrap, .ins-icons-wrap {
      height: 20px;
      width: 20px;
      position: relative;
      float: left;
      margin: 2px 4px 0 0;
      @media (max-width: 600px) {
        transform: scale(0.75);
        transform-origin: 50% 50%;
      }

      & > .img {
        bottom: 0;
        left: 0;
        margin: auto;
        max-height: 20px;
        max-width: 20px;
        position: absolute;
        right: 0;
        top: 0;
        vertical-align: middle;
        background: {
          size: auto;
          repeat: no-repeat;
        };
        display: inline-block;
      }
    }

    .source-icon {
      font-size: 12px;
      padding: 2px;
      color: #fff;
      background-color: #3B5998;
      display: inline-block;
      height: 16px;
    }
  }

  .info-detail {
    font-size: 14px;
    color: #999;

    p {
      margin: 0;
    }
  }

  .book-btns {
    margin-top: 10px;

    button {
      min-width: 80px;
      font-weight: 500;
      @media (max-width: 330px) {
        width: 60px;
      }
    }
  }

  // 删除按钮
  .book-item__action {
    padding: 0;
    position: absolute;
    top: 0;
    right: 0;
    height: 24px;
    line-height: 24px;
    width: 24px;
    color: white;
    cursor: pointer;

    i {
      position: relative;
      z-index: 2;
    }

    &:before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
      border: {
        top: 20px solid #41c1ad;
        right: 20px solid #41c1ad;
        left: 20px solid transparent;
        bottom: 20px solid transparent;
      }
    }

    &.bin {
      &:before {
        border-top-color: #999 !important;
        border-right-color: #999 !important;
      }
    }

    span {
      color: #333;
      font-size: 12px;
    }

    .pointer {
      max-width: 3em;
      position: absolute;
      left: -3em;
      bottom: -1.75em;
      @media (max-width: 767px) {
        max-width: 2.8em;
        left: -3.4em;
        bottom: -1.05em;
      }
    }
  }

  .action-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .35);
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;

    .sub-action {
      color: white;
      cursor: pointer;

      & > div {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        width: 40px;
        background-color: rgba(255, 255, 255, .35);
        border: 2px solid white;
        border-radius: 50%;
      }

      p {
        font-size: 14px;
        font-weight: 600;
      }
    }

    .sub-action + .sub-action {
      margin-left: 30px;
    }
  }

  .slide-down-enter-active, .slide-down-leave-active {
    transition: all .35s
  }

  .slide-down-enter, .slide-down-leave-to /* .fade-leave-active in below version 2.1.8 */
  {
    opacity: 0;
    transform: translateY(-50px);
  }
}
</style>
